// All keys outside the store object will be deleted on the logout
interface Keys {
  store: {
    main: {
      cookiesSettings: string;
      equity: string;
    },
    onboarding: {
      companyDetails: {
        showInfo: string;
      }
      delegatedTradeReporting: {
        showInfo: string;
      }
    };
  },
  main: {
    token: string;
    user: string;
  },
  onboarding: {
    token: string;
    applicationId: string;
    applicationStatus: string;
    applicationResubmitted: string;
    prospectPermission: string;
    stepCompleted: string;
  }
}

const keys: Keys = {
  store: {
    main: {
      cookiesSettings: 'COOKIES_SETTINGS',
      equity: 'EQUITY'
    },
    onboarding: {
      companyDetails: {
        showInfo: 'SHOW_COMPANY_DETAILS_INFO'
      },
      delegatedTradeReporting: {
        showInfo: 'SHOW_DELEGATED_TRADE_REPORTING_INFO'
      }
    }
  },
  main: {
    token: 'MSAL_TOKEN',
    user: 'MSAL_USER',
  },
  onboarding: {
    token: 'MSAL_TOKEN_ONBOARDING',
    applicationId: 'APP_ID',
    applicationStatus: 'APPLICATION_STATUS',
    applicationResubmitted: 'APPLICATION_RE',
    prospectPermission: 'PROSPECT_PERMISSION',
    stepCompleted: 'STEP_COMPLETED'
  }
}

const get = (key: string, isLocalStorage?: boolean) => {
  if (isLocalStorage) {
    return JSON.parse(localStorage.getItem(key))
  }
  return JSON.parse(sessionStorage.getItem(key))
}

const set = (key: string, value: unknown, isLocalStorage?: boolean): void => {
  if (isLocalStorage) {
    localStorage.setItem(key, JSON.stringify(value))
  } else {
    sessionStorage.setItem(key, JSON.stringify(value))
  }
}

export default {
  keys,
  get,
  set,
}
